<template>
 <div class="col-12 py-1 px-0">
  <load v-if="loading" mode="table" />
  <div class="card card-body table table-sm bg-white border-4 border-bottom border-primary"
   v-for="historico in historicos" :key="historico.id" v-if="historico.new_values">
   <div class="row py-2" style="border-bottom: 2px solid #007bff !important">
    <!-- <div class="col-12 py-1">
      <button class="btn btn-warning btn-sm" @click="restaurar">
           <i class="mdi mdi-undo mr-3"></i>Restaurar
         </button>
     </div> -->
    <div class="col-6">
     <b>DATA DE REGISTRO:</b>
     {{ historico.created_at | moment("DD/MM/YYYY") }}<br />
     <b>EVENTO:</b> {{ historico.event }}
    </div>
    <div class="col-6">
     <b>RESPONSÁVEL PELA EDIÇÃO:</b> {{ historico.tecnico.nome }} -
     <small>{{ historico.tecnico.unidade.nome }} </small>
    </div>
   </div>
   <div class="row" v-html="makeHTML(historico.new_values.protocolo, 'PROTOCOLO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.cadastrado, 'CADASTRADO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.responsavel, 'TÉCNICO RESPONSÁVEL', 'name')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.unidade, 'UNIDADE DO RESPONSÁVEL', 'nome')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.outros_tecnicos, 'OUTRO(S) TÉCNICO(S)', null, true)"></div>
   <div class="row" v-html="makeHTML(historico.new_values.tipo, 'TIPO DE ATENDIMENTO')"></div>
   <div class="row" v-if="historico.new_values.tipo == 'ABORDAGEM SOCIAL'"
    v-html="makeHTML(historico.new_values.situacao_abordagem_social_nomes, 'SITUAÇÕES IDENTIFICADAS NA ABORDAGEM SOCIAL')">
   </div>
   <div class="row"
    v-html="makeHTML(historico.new_values.outra_situacao_abordagem_social, 'OUTRAS SITUAÇÕES IDENTIFICADAS')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.status_nome, 'STATUS')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.privado, 'SIGILO', null, false, true, ['1', 'Sim', 'Não'])"></div>

   <div class="row">
    <div class="col-12" v-if="historico.new_values.familia">
    <b>USUÁRIO(S) ATENDIDO(S):</b>
     <b class="mr-2 badge badge-default" v-for="(pessoa, index) in historico.new_values.pessoas" :key="pessoa.id">
      {{ pessoa.nome_completo }}
     </b>
     <small class="badge badge-danger my-2" v-if="
      historico.new_values.familia.rf_situacao_rua != null &&
      historico.new_values.familia.rf_situacao_rua.status == 1
     ">RF registrado em Situação de Rua no Sistema</small>
    </div>
   </div>

   <div class="row" v-html="makeHTML(verificarValueArray(historico.new_values.tipo_servico_id, servicos), 'SERVIÇO')">
   </div>
   <div class="row"
    v-html="makeHTML(verificarValueArray(historico.new_values.local, $root.arrays.atendimento_local), 'LOCAL DE ATENDIMENTO')">
   </div>
   <div class="row" v-html="makeHTML(historico.new_values.outra_unidade_id, 'OUTRA UNIDADE')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.outra_unidade, 'OUTRA UNIDADE')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.data_prevista_formatado, 'DATA DO AGENDAMENTO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.hora_prevista_formatado, 'HORA DO AGENDAMENTO')"></div>
   <div class="row" v-html="makeHTML(historico.new_values.descricao_sumaria, 'OBSERVAÇÃO')"></div>


   <div class="row">
    <div class="col-12 py-1" v-if="historico.new_values.vulnerabilidades">
     <b>VULNERABILIDADE(S):</b>
     <b class="mr-2 badge badge-default" v-for="(vulnerabilidade, index) in historico.new_values
      .vulnerabilidades" :key="vulnerabilidade.id">
      {{ verificarValueArray(vulnerabilidade, vulnerabilidades_tipos) }}
     </b>
    </div>
    <div class="col-12 py-1" v-if="
     historico.new_values.denuncias &&
     historico.new_values.denuncias.length > 0
    ">
     <b>DENÚNCIAS:</b>
     <b class="mr-2 badge badge-default" v-for="(denuncia, index) in historico.new_values
      .denuncias" :key="index">
      <router-link v-if="denuncia" class="btn btn-sm btn-light py-0 px-1 my-1"
       :to="`/dashboard/denuncias/edit/${denuncia.id}`">
       {{ denuncia.protocolo }}
      </router-link>
     </b>
    </div>
   </div>
  </div>
  <h2 v-if="historicos.length <= 0" class="text-warning">
   <span class="mdi mdi-clipboard-search-outline"></span> Por enquanto
   não temos nenhuma atualização.
  </h2>
 </div>
</template>
<script>
export default {
 props: ["id", "vulnerabilidades"],
 data() {
  return {
   loading: true,
   historicos: {},
   servicos: [],
   unidades: [],
   vulnerabilidades_tipos: [],
  };
 },
 watch: {
  vulnerabilidades() {
   this.vulnerabilidades_tipos = this.vulnerabilidades;
  },
 },
 mounted() {
  this.vulnerabilidades_tipos = this.vulnerabilidades;
  this.getHistorico();
  // this.getServicos();
  // this.getUnidades();
 },
 methods: {
  getHistorico() {
   this.loading = true;
   axios
    .get("api/dashboard/atendimento/historico/audit/" + this.id)
    .then((response) => {
     this.historicos = response.data.historicos;
     this.servicos = response.data.servicos;
    })
    .finally(() => {
     this.loading = false;
    })
    .catch(() => {
     swal.fire({
      title: "Ops!",
      html: `Os dados de auditoria não foram carregado corretamente<br>${error}`,
      icon: "error",
     });
    });
  },
  restaurar() {
   console.log("teste");
  },
  // getServicos() {
  //  axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
  //   this.servicos = response.data;
  //  });
  // },
  // getUnidades() {
  //  axios
  //   .get(`api/dashboard/unidades/get/externas/PLANTAO`)
  //   .then((response) => {
  //    this.unidades = response.data;
  //   });
  // },
  makeHTML(value, label, index = null, loop = false, select = false, options = null) {
   if (value != null && value != '') {
    if (loop) {
     let itens = "";
     value.forEach(item => {
      itens += `<b class="mr-2 badge badge-default">${item}</b>`;
     });
     return `<div class="col-12 py-1"><b>${label}:</b> ${itens}</div>`;
    } else if (select) {
     return `<div class="col-12 py-1"><b>${label}:</b> ${value == options[0] ? options[1] : options[2]}</div>`;
    } else {
     value = typeof value === "object" ? value[index] : value;
     return `<div class="col-12 py-1"><b>${label}:</b> ${value}</div>`;
    }
   }
  },
  verificarValueArray(value, array) {
   if (value != null && value != '') {
    const result = array.find((item) => item.id == value);
    return result ? result.value : "";
   }
  },
 },
};
</script>
